import styled from "styled-components";

export const Page = styled.div`
  flex: 1 1 auto;

  background-color: var(--color-roxo);

  display: flex;
  justify-content: center;
  // align-items: center;

  overflow: hidden;

  @media (min-width: 1200px) {
    padding: 15px 15px 0 15px;
    height: 100vh;
  }
`;

export const Container = styled.div`
  display: none;

  @media (min-width: 1200px) {
    flex: 1 1 auto;
    height: 100vh;

    background-image: url("/src/assets/images/Comilão.png");
    background-color: var(--color-roxo);

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    overflow: hidden;

    padding: 0 15px;
  }
`;

export const Ilustracoes = styled.div`
  display: none;

  @media (min-width: 1200px) {
    display: flex;
    flex: 1 1 auto;

    align-items: flex-end;

    img {
      // width: 280px;
      height: 300px;
    }
    padding-bottom: 20px;
  }
`;

export const Mobile = styled.div`
  flex: 1 1 auto;

  background-color: #fff;
  border-radius: 10px 10px 0 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  overflow: hidden;

  @media (min-width: 1200px) {
    display: none;
  }
`;

export const Title = styled.div`
  font-size: 23px;
  font-weight: bold;
  width: 90%;

  padding-top: 20px;
`;
export const KitList = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  padding: 20px 0;

  overflow: auto;
`;
